import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTenantSubject } from '@services/registry';

export function useUpdateTenantSubject({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ subjectId, payload }) => {
            return await updateTenantSubject({ tenantId, subjectId, payload });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['tenantSubjects', tenantId] });
        },
    });
}

